let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7ALpX")).then(() => parcelRequire('hShQh'));